/**
 * RegistrationTable - Main registration totals table
 * @module wellRegistrationTotals/components/organisms/RegistrationTable/RegistrationTable
 */

import React from "react";
import { Table, TableBody, Paper, Box } from "@material-ui/core";
import { StyledTableContainer } from "../../../styled";
import Loader from "../../../../../../../components/Loader";
import TableHeader from "./TableHeader";
import ReportTableRow from "./ReportTableRow";

/**
 * Registration totals table with clickable rows
 * @param {Object} props
 * @param {Array} props.data - Table data rows
 * @param {boolean} props.isLoading - Loading state
 * @param {Function} props.onRowClick - Row click handler
 * @param {Object|null} props.selectedRow - Currently selected row
 */
const RegistrationTable = React.memo(
  ({ data, isLoading, onRowClick, selectedRow }) => (
    <StyledTableContainer component={Paper}>
      {isLoading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="200px"
        >
          <Loader />
        </Box>
      ) : (
        <Table size="small">
          <TableHeader firstColumnLabel="Year" />
          <TableBody>
            {(data || []).map((row, index) => (
              <ReportTableRow
                key={index}
                row={row}
                onRowClick={onRowClick}
                selectedRow={selectedRow}
              />
            ))}
          </TableBody>
        </Table>
      )}
    </StyledTableContainer>
  )
);

RegistrationTable.displayName = "RegistrationTable";

export default RegistrationTable;
